import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import React from 'react';
import {doppeActionTypeLocationMap} from './doppe-action-type-location-map';

/**
 * Viewer metadata for the Location Map action type.
 * Defines how the location map action is rendered in the viewer and how CTA activation works.
 */
export const doppeActionTypeLocationMapViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeLocationMap, {
    /**
     * Lazy load the widget component.
     */
    loadViewerComponents: async () => {
        return {
            DoppeActionTypeLocationMapWidget: (
                await import('./doppe-action-type-location-map-widget/doppe-action-type-location-map-widget')
            ).DoppeActionTypeLocationMapWidget
        };
    },

    /**
     * Render the location map widget.
     */
    renderWidget: (renderProps, viewerComponents) => {
        const {DoppeActionTypeLocationMapWidget} = viewerComponents;

        return <DoppeActionTypeLocationMapWidget {...renderProps} />;
    },

    /**
     * CTA activation for location map action - doesn't navigate to a URL since map is shown inline.
     * The main interaction is through the widget itself (opening modal, navigating to location).
     */
    activateCTA: _actionContext => {
        // Location Map action doesn't have a primary CTA URL to navigate to
        // User interactions happen through the widget (expand map modal, navigate to location)
    }
});
